import { render, staticRenderFns } from "./AfterDialog.vue?vue&type=template&id=797ebeb3&scoped=true"
import script from "./AfterDialog.vue?vue&type=script&lang=js"
export * from "./AfterDialog.vue?vue&type=script&lang=js"
import style0 from "./AfterDialog.vue?vue&type=style&index=0&id=797ebeb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ebeb3",
  null
  
)

export default component.exports